import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHistory, faSignOutAlt, faUser, faHome, faTrophy, faCreditCard, faBullhorn } from '@fortawesome/free-solid-svg-icons';
import { User } from '../config/Registration';
import UserAvatar from './UserAvatar';
import './TerminalHeader.css';

interface BurgerMenuProps {
  user: User;
  onHistoryClick: () => void;
  onProgressClick: () => void;
  onLogoutClick: () => void;
  onHomeClick: () => void;
  onProfileClick: () => void;
  onPackagesMembershipClick?: () => void;
  onWhatsNewClick?: () => void;
  isCheckinStep: boolean;
  isHistoryStep: boolean;
  isProgressStep: boolean;
}

const BurgerMenu: React.FC<BurgerMenuProps> = ({
  user,
  onHistoryClick,
  onProgressClick,
  onLogoutClick,
  onHomeClick,
  onProfileClick,
  onPackagesMembershipClick,
  onWhatsNewClick,
  isCheckinStep,
  isHistoryStep,
  isProgressStep
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  return (
    <div className="burger-menu-container" ref={menuRef}>
      <UserAvatar user={user} onClick={toggleMenu} />
      
      {showMenu && (
        <div className="burger-dropdown">
          <button className="dropdown-item" onClick={() => {
            toggleMenu();
            onProfileClick();
          }}>
            <FontAwesomeIcon icon={faUser} className="button-icon" />
            <span>Profile</span>
          </button>

          {onPackagesMembershipClick && (
            <button className="dropdown-item" onClick={() => {
              toggleMenu();
              onPackagesMembershipClick();
            }}>
              <FontAwesomeIcon icon={faCreditCard} className="button-icon" />
              <span>Packages &amp; Membership</span>
            </button>
          )}

          {onWhatsNewClick && (
            <button className="dropdown-item" onClick={() => {
              toggleMenu();
              onWhatsNewClick();
            }}>
              <FontAwesomeIcon icon={faBullhorn} className="button-icon" />
              <span>What's New</span>
            </button>
          )}

          {!isCheckinStep && (
            <button className="dropdown-item" onClick={() => {
              toggleMenu();
              onHomeClick();
            }}>
              <FontAwesomeIcon icon={faHome} className="button-icon" />
              <span>Check-in</span>
            </button>
          )}

          {!isHistoryStep && (
            <button className="dropdown-item" onClick={() => {
              toggleMenu();
              onHistoryClick();
            }}>
              <FontAwesomeIcon icon={faHistory} className="button-icon" />
              <span>History</span>
            </button>
          )}

          {!isProgressStep && (
            <button className="dropdown-item" onClick={() => {
              toggleMenu();
              onProgressClick();
            }}>
              <FontAwesomeIcon icon={faTrophy} className="button-icon" />
              <span>My Progress</span>
            </button>
          )}

          <button className="dropdown-item" onClick={() => {
            toggleMenu();
            onLogoutClick();
          }}>
            <FontAwesomeIcon icon={faSignOutAlt} className="button-icon" />
            <span>Logout</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default BurgerMenu; 
